export default "__VITE_ASSET__DTPiCCzD__"